<cll-card appearance="outlined">
    <cll-card-header>
        <cll-card-title>Rules</cll-card-title>

        <cll-card-header-actions>
            <button cll-button class="float-right" (click)="addRule()">
                Add rule
            </button>
        </cll-card-header-actions>
    </cll-card-header>

    <ng-container *ngFor="let rule of value; let i = index; trackBy: _trackRuleFn">
        <app-contract-rule
            [disabled]="disabled"
            [(rule)]="value[i]"
            (ruleChange)="dispatchChange()"
            (remove)="removeRule(rule)" />
    </ng-container>
</cll-card>
